export default __webpack_public_path__ + "static/media/Me.7253966e.png";